import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  closeIcon: { marginRight: 4 },
  button: {
    '&:hover': {
      '& svg path': {
        fill: isKiteUser ? '#3C89D0' : '#3C7BA3',
      },
      '& span': {
        color: isKiteUser ? '#3C89D0' : '#3C7BA3',
      },
    },
  },
}));
